"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TankShape = void 0;
var TankShape;
(function (TankShape) {
    TankShape["CYLINDER"] = "CYLINDER";
    TankShape["RECTANGLE"] = "RECTANGLE";
})(TankShape || (exports.TankShape = TankShape = {}));
